(() => {
  'use strict';

  const SELECTORS = {
    root: '[data-image-arrows]',
    slider: '[data-hover-slider]',
    arrow: '[data-image-arrow]',
    hidden: 'is-hidden',
  };

  function getIndex(slider) {
    const width = slider.clientWidth || 1;
    return Math.round(slider.scrollLeft / width);
  }

  function getMaxIndex(slider) {
    const width = slider.clientWidth || 1;
    return Math.max(0, Math.round(slider.scrollWidth / width) - 1);
  }

  function updateArrows(root, index, maxIndex) {
    const prev = root.querySelector(`${SELECTORS.arrow}[data-image-arrow="prev"]`);
    const next = root.querySelector(`${SELECTORS.arrow}[data-image-arrow="next"]`);

    if (prev) {
      prev.classList.toggle(SELECTORS.hidden, index <= 0);
    }

    if (next) {
      next.classList.toggle(SELECTORS.hidden, index >= maxIndex);
    }
  }

  function goTo(root, direction) {
    const slider = root.querySelector(SELECTORS.slider);
    if (!slider) return;

    const width = slider.clientWidth || 1;
    const maxIndex = getMaxIndex(slider);
    let index = getIndex(slider);

    index = direction === 'next' ? Math.min(index + 1, maxIndex) : Math.max(index - 1, 0);
    slider.scrollTo({ left: index * width, behavior: 'smooth' });
    updateArrows(root, index, maxIndex);
  }

  function onClick(event) {
    const button = event.target.closest(SELECTORS.arrow);
    if (!button) return;

    const root = button.closest(SELECTORS.root);
    if (!root) return;

    event.preventDefault();
    event.stopPropagation();

    goTo(root, button.getAttribute('data-image-arrow'));
  }

  function onScroll(event) {
    const slider = event.currentTarget;
    const root = slider.closest(SELECTORS.root);
    if (!root) return;

    updateArrows(root, getIndex(slider), getMaxIndex(slider));
  }

  function initRoot(root) {
    if (root.dataset.imageArrowsReady === 'true') return;
    root.dataset.imageArrowsReady = 'true';

    const slider = root.querySelector(SELECTORS.slider);
    if (!slider) return;

    updateArrows(root, getIndex(slider), getMaxIndex(slider));
    slider.addEventListener('scroll', onScroll, { passive: true });
  }

  function initAll() {
    document.querySelectorAll(SELECTORS.root).forEach(initRoot);
  }

  document.addEventListener('click', onClick, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
